import { type ReactNode } from "react";
import type {
  RoadmapItemLongTerm,
  RoadmapItemShortTerm,
} from "@/services/api/types";
import * as Styled from "./styled";
import useDragScroll from "@/hooks/useDragScroll";
import ItemCard from "../ItemCard";

const DraggableRoadmapRow = ({ children }: { children: ReactNode }) => {
  const scrollRef = useDragScroll<HTMLDivElement>();
  return <Styled.RoadmapRow ref={scrollRef}>{children}</Styled.RoadmapRow>;
};

type Props = {
  data: Record<string, RoadmapItemShortTerm[] | RoadmapItemLongTerm[]>;
  handleSelect: (item: RoadmapItemShortTerm | RoadmapItemLongTerm) => void;
};

const Roadmap = ({ data, handleSelect }: Props) => {
  const isShortTermItem = (
    item: RoadmapItemShortTerm | RoadmapItemLongTerm,
  ): item is RoadmapItemShortTerm => "itemStatus" in item;

  const getTierRank = (item: RoadmapItemShortTerm | RoadmapItemLongTerm) =>
    isShortTermItem(item) && item.isTier1 ? 0 : 1;

  const getSortValue = (item: RoadmapItemShortTerm | RoadmapItemLongTerm) =>
    typeof item.sort === "number" ? item.sort : 0;

  return (
    <Styled.RoadmapContainer>
      {Object.keys(data).map((category) => (
        <Styled.RoadmapRowWrapper key={category}>
          <Styled.ProductRowHeader>{category}</Styled.ProductRowHeader>
          <DraggableRoadmapRow>
            {[...data[category]]
              .sort((a, b) => {
                const tierDiff = getTierRank(a) - getTierRank(b);

                if (tierDiff !== 0) {
                  return tierDiff;
                }

                return getSortValue(a) - getSortValue(b);
              })
              .map((item) => {
                return (
                  <div key={item.id}>
                    <ItemCard
                      item={item}
                      onClick={() => handleSelect(item)}
                    />
                  </div>
                );
              })}
          </DraggableRoadmapRow>
        </Styled.RoadmapRowWrapper>
      ))}
    </Styled.RoadmapContainer>
  );
};

export default Roadmap;